<template>
  <div class="number-input" v-show="show">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'" :for="options.name">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <input class="form-control" type="text"
          :class="formControlValidationClass"
          :placeholder="options.placeholder || ''"
          :id="options.name"
          :value="value"
          @input="validate($event.target.value)"
          :name="options.name"/>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {
  validationClass,
  formControlValidationClass,
  validationMessage
} from '@/util/helpers'
import Api from '../../vuex/api'

export default {
  name: 'NumberInput',
  props: {
    value: {
      type: [Number, String]
    },
    options: {
      type: Object,
      default () {
        return {
          value: ''
        }
      }
    }
  },
  data () {
    return {
      isDirty: false,
      isValid: false,
      isLength: false,
      isRegex: false,
      regex: /^[0-9]+$/,
      minVal: false,
      maxVal: false,
      show: true
    }
  },
  computed: {
    validationClass,
    formControlValidationClass,
    validationMessage,
    invalidMessage () {
      if (this.minVal && this.minVal !== 0 && Math.ceil(this.value) < this.minVal) {
        return 'You may only enter a mininum number ' + this.minVal
      } else if (this.maxVal && this.maxVal !== 0 && Math.ceil(this.value) > this.maxVal) {
        return 'You may only enter a number up to ' + this.maxVal
      } else if (!this.options.required) {
        return 'The number entered is not valid'
      } else {
        return this.options.label + ' is required'
      }
    }
  },
  mounted () {
    if (this.options.maxVal) this.maxVal = this.options.maxVal
    if (this.options.minVal) this.minVal = this.options.minVal
    this.validate(this.value)
    // for number of owner corporation field, set to false initially
    if (this.options.label === 'Number of Owner Corporation' && this.options.name === 'numberOfOC') {
      this.show = false; /* Hack */
    }
  },
  methods: {
    validate (val = this.value) {
      val = val === undefined ? '' : val
      this.$emit('input', val)
      if (this.options.required) {
        this.isDirty = true
        this.isValid = !Number.isNaN(Math.floor(val)) && val !== '' && !val.toString().includes('.')
        if (this.maxVal && this.maxVal !== 0) {
          this.isValid = this.isValid && Math.ceil(val) <= this.maxVal
        }
        if (this.minVal && this.minVal !== 0) {
          this.isValid = this.isValid && Math.ceil(val) >= this.minVal
        }
        this.isLength = val.length >= this.minLength
      } else {
        this.isDirty = val && val !== ''
        this.isValid = !Number.isNaN(Math.floor(val)) && !val.toString().includes('.')
        if (this.maxVal && this.maxVal !== 0) {
          this.isValid = this.isValid && Math.ceil(val) <= this.maxVal
        }
        if (this.minVal && this.minVal !== 0) {
          this.isValid = this.isValid && Math.ceil(val) >= this.minVal
        }
      }
    },
    async runWatcher (val, name) {
      if (this.options.watchers.includes(name)) {
        switch (name) {
          case 'QuoteTypeUuid':
            await this.updateVisibility(val)
            break
        }
      }
    },
    async updateVisibility(val) { /* Hack */
      /*
      let instance = new Api()
      let quoteTypeDetail = await instance.getQuoteTypeDetail(val)
      const quoteName = quoteTypeDetail.quoteName 
      console.log(`Update visibility: ${quoteName}`)
      if (quoteName === 'Maintenance Plan') {
        if (this.options.name === 'numberOfOC') {
          this.show = true
        } else if (this.options.name === 'levels') {
          this.show = false
        }
      } else if (quoteName === 'Insurance Reinstatement & Replacement' ){
        if (this.options.name === 'levels') {
          this.show = true
        } else if (this.options.name === 'numberOfOC') {
          this.show = false
        }
      } */
      if (val === '80b39eae-74e2-456d-a257-1c27ed29a560' /* QuoteType Uuid for Insurance plan */  ) { 
        // insurance plan
        if (this.options.name === 'levels') {
          this.show = true;
        } else if (this.options.name === 'numberOfOC') {
          this.show = false;
        }
      } else if (val === '30dfc3e6-ae19-4083-85fc-345ff4339541' /* QuoteTYpe Uuid for Maintenance plan */ ) {
        // maintenanace plan
        if (this.options.name === 'numberOfOC') {
          this.show = true
        } else if (this.options.name === 'levels') {
          this.show = false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/NumberInput.vue